<template>
  <div class="box"
       id="homeBox">
    <div class="home-top">
      <div class="home-top-left">
        <div class="header">
          <img v-if="userInfo && userInfo.selfImagePath"
               :src="userInfo && userInfo.selfImagePath"
               alt="" />
          <img v-else
               src="~/assets/img/avatar.png"
               alt="" />
        </div>
        <img class="robot"
             src="../../assets/img/robot.png"
             alt="" />
        <div class="top">
          <div class="top-box">
            <div style="padding-right: 10px; font-size: 21px">
              <span> 欢迎您，{{ userInfo && userInfo.cname }}</span>
            </div>
          </div>
          <div class="top-box">
            <div><span class="label">版本：</span> <span>免费版</span></div>
            <div>
              <span class="label">企业：</span>
              <span style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  display: inline-block;
                  width: 180px;
                  text-align: left;
                ">{{
                  $store.state.companyName ? $store.state.companyName : "无"
                }}</span>
            </div>
            <div>
              <span class="label">状态：</span>
              <span v-if="$store.state.authenticationState === 2">已认证</span>
              <span v-if="$store.state.authenticationState === 1">认证中</span>
              <span @click="$router.push('/certifiSelection')"
                    style="
                  cursor: pointer;
                  color: rgb(206, 162, 87);
                  text-decoration: underline;
                "
                    v-if="$store.state.authenticationState === 0">未认证</span>
              <span @click="$router.push('/certifiSelection')"
                    style="cursor: pointer; color: red"
                    v-if="$store.state.authenticationState === 3">认证未通过</span>
            </div>
          </div>
        </div>
      </div>
      <div class="home-top-center">
        <template v-for="(item, i) in menuList">
          <div @click="nav(item.actionUrl)"
               class="icon"
               :key="i"
               v-if="item.isMainShortcut"
               :style="{
              backgroundImage: `url(${
                item.extendStyleClass == 'blue'
                  ? blue
                  : item.extendStyleClass == 'purple'
                  ? purple
                  : item.extendStyleClass == 'lightblue'
                  ? lightblue
                  : item.extendStyleClass == 'cyan'
                  ? cyan
                  : ''
              })`,
            }">
            <div style="height: 65px">
              <img style="width: 50px"
                   :src="imagePath(item.unselectedIconPath)"
                   alt="" />
            </div>
            <div style="font-size: 16px; font-weight: 400; color: #fff">
              {{ item.menuName }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="home-bottpm"
         style="display: flex; justify-content: space-between">
      <div style="display: flex; flex: 1">
        <div class="home-bottpm-left">
          <img class="borderDecoration"
               src="../../assets/img/borderDecoration.png"
               alt="" />
          <div class="title">系统通知</div>

          <Note />
          <!-- <div style="height: 100%">
            <div id="main3"
                 style="width: 100%; height: 200px"></div>
            <div class="statisticsBox">
              <div class="label">总人数</div>
              <div class="label">企业数量</div>
              <div class="label">职位数量</div>
              <div class="label">开卡数量</div>
              <div class="label">信用卡数量</div>
              <div class="label">社保卡数量</div>
              <div class="label">个人贷款数量</div>
              <div class="label">企业银行账户数量</div>
              <div class="label">投保数量</div>
            </div>
          </div> -->
        </div>
        <div class="home-bottom-center">
          <img class="borderDecoration"
               src="../../assets/img/borderDecoration.png"
               alt="" />
          <!-- <div class="msg-top">
            <span class="msg-title">系统通知</span>
          </div> -->
          <img style="width: 100%;height: 310px;"
               src="../../assets/img/advertisement.jpg"
               alt="" />
        </div>
        <div class="roll">
          <img class="borderDecoration"
               src="../../assets/img/borderDecoration.png"
               alt="" />
          <div class="roll-title">资讯新闻</div>
          <news />
        </div>
      </div>
    </div>
    <advertisingBanner :visible="advertisingBannerVisible"
                       @close="advertisingBannerVisible = false"></advertisingBanner>
  </div>
</template>

<script>
// import $http from "@/request/http";

import * as echarts from "echarts";
import Note from "@/components/Note";
import news from "./news";
import advertisingBanner from "./advertisingBanner";

export default {
  components: { Note, news, advertisingBanner },
  data () {
    return {
      purple: require("../../assets/img/purple.png"),
      lightblue: require("../../assets/img/lightblue.png"),
      blue: require("../../assets/img/blue.png"),
      cyan: require("../../assets/img/cyan.png"),
      currentUserInfo: "",
      advertisingBannerVisible: false,
      time: 0,
      userStatus: "",
      Company: "",
      userInfo: "",
      name: {},
      dialogVisible: false,
      messageContent: "",
      messageTitle: "",
      active: 0,
      activeFont: false,
      myname: "",
      noteList: [],
      allCount: 0,
      readyCount: 0,
      menuList: [],
    };
  },
  mounted () {
    this.CompanyUserStateStatisticsData();
    // this.CompanyDetail();
    this.getUserInfo();
    this.getRightsMenus();
    let _this = this;
    _this.bodyScale();
    this.$nextTick(() => {
      window.onresize = function () {
        _this.bodyScale();
      };
    });
    // if (!window.localStorage.getItem("firstView")) {
    //   this.dialogVisible = true;
    // }
    // window.localStorage.setItem("firstView", true);
  },

  methods: {
    imagePath (name) {
      if (name) {
        return require(`../../assets/img/nav/${name}`);
      }
    },
    bodyScale () {
      //获取当前分辨率下的可是区域宽度
      var devicewidth = document.documentElement.clientWidth;
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.getElementById("homeBox").style.zoom = scale; //放大缩小相应倍数
      console.log(document.getElementById("lin_Search"));
    },
    getRightsMenus () {
      this.loading = true;
      this.$api.user.getRightsMenus().then((res) => {
        this.loading = false;
        if (res.code == 0) {
          res.data.forEach((v) => {
            if (v.parentId == 0) {
              if (v.id == 59 && this.Company.authenticationState == 0) {
                return;
              }
              if (!v.menuName) return;
              if (v.id == 61 && v.children && v.children.length > 0) {
                v.children.forEach((childItem) => {
                  if (childItem.id == 75) {
                    this.$set(v, "actionUrl", "personnelList");
                    this.menuList.push(v);
                  }
                });
              } else if (v.id == 68 && v.children && v.children.length > 0) {
                v.children.forEach((childItem) => {
                  if (childItem.id == 76) {
                    this.$set(v, "actionUrl", "insuranceList");
                    this.menuList.push(v);
                  }
                });
              } else if (v.id == 2117 && v.children && v.children.length > 0) {
                v.children.forEach((childItem) => {
                  if (childItem.id == 66) {
                    this.$set(v, "actionUrl", "salaryCalculationList");
                    this.menuList.push(v);
                  }
                });
              } else if (v.id == 2116 && v.children && v.children.length > 0) {
                v.children.forEach((childItem) => {
                  if (childItem.id == 84) {
                    this.$set(v, "actionUrl", "debitCardList");
                    this.menuList.push(v);
                  }
                });
              } else if (v.id == 2200 && v.children && v.children.length > 0) {
                v.children.forEach((childItem) => {
                  if (childItem.id == 2099) {
                    this.$set(v, "actionUrl", "businessLoan");
                    this.menuList.push(v);
                  }
                });
              } else if (v.id != 61 && v.id != 68 && v.id != 2101) {
                this.menuList.push(v);
              }
            }
          });
        }
      });
    },
    getPicture () {
      var chartDom3 = document.getElementById("main3");
      var myChart3 = echarts.init(chartDom3);
      var option3;
      option3 = {
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: [
            "待处理",
            "待面试",
            "面试未通过",
            "待入职",
            "未入职",
            "已入职",
            "已离职",
            "已离职(自离)",
          ],
          axisLabel: {
            //  X 坐标轴标签相关设置
            interval: 0,
            rotate: "45",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.userStatus,
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" },
                ]),
              },
            },
          },
        ],
      };
      option3 && myChart3.setOption(option3);
      // this.MessagePage(false);
      // this.MessagePage2(true);
    },
    // 用户统计
    CompanyUserStateStatisticsData () {
      this.$api.user.CompanyUserStateStatisticsData().then((res) => {
        if (res.code === 0) {
          let arr = [];
          res.data.forEach((element) => {
            arr.push(element.dataCount);
          });
          this.userStatus = arr;
          this.getPicture();
        }
      });
    },
    getUserInfo () {
      this.$api.user.GetCompanyManageUserInfo().then((res) => {
        if (res.code === 0) {
          this.userInfo = res.data;
          window.localStorage.setItem(
            "userInfo",
            JSON.stringify(this.userInfo)
          );
        }
      });
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);

        }
      });
    },
    activeIcon (i) {
      this.active = i;
    },
    stop () {
      this.$confirm("功能暂未开放，更多敬请期待！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        type: "warning",
        center: true,
      })
        .then(() => { })
        .catch(() => { });
    },
    nav (url) {
      this.$router.push(url);
    },
    goauthentication () {
      this.$parent.$parent.$parent.$children[0].goauthentication();
    },
    readMessage (id) {
      let formData = new FormData();
      formData.append("id", id);
      this.$api.manage.MessageRead(formData).then((res) => {
        if (res.code === 0) {

          this.MessagePage(false);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    see (v) {
      // this.dialogVisible = true;
      this.messageContent = v.messageContent;
      this.messageTitle = v.title;
      this.readMessage(v.id);
    },
  },
};
</script>
<style lang="less">
.home-bottpm-left {
  .list-time {
    margin-right: 30px !important;
  }
  .list-title {
    width: 400px !important;
  }
}

.home-tip {
  .button {
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #333;
    color: #fff;
  }
  .label01 {
    font-size: 15px;
    margin-top: -40px;
    line-height: 30px;
    color: #020000;
    font-weight: bold;
  }
  //弹窗，走马灯
  .scrollable {
    height: 500px;
    overflow-y: scroll;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #fff;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #fff;
  }
}
.el-step__head.is-wait {
  color: black !important;
  border-color: black !important;
}
.el-step__title.is-process,
.el-step__title.is-wait {
  color: black !important;
}
.el-step__head.is-process,
.el-step__heads.is-wait {
  .el-step__icon.is-text {
    //这里设置的是下一步和等待状态里的文字颜色
    color: black !important;
    border-color: black !important;
  }
}
.el-step__description.is-wait {
  color: black !important;
}

.el-main {
  overflow-x: auto !important;
}
</style>
<style lang="less" scoped>
#homeBox {
  padding-bottom: 25px;
}
.box {
  // padding: 10px 40px 0px;
  // padding-top: 10px;
  width: 100%;
  // height: calc(100% - 35px);
  background-color: #f3f4f8;
  .home-top {
    display: flex;
    justify-content: space-between;
    .home-top-left {
      width: 620px;
      min-width: 620px;
      // height: 380px;
      border-radius: 10px;
      position: relative;
      box-shadow: 1px 6px 13px 0px #d0d0d0;
      border-radius: 25px;
      background-image: url(../../assets/img/pf-bg.png);
      .robot {
        width: 220px;
        position: absolute;
        left: 455px;
        top: 155px;
      }
      .header {
        position: absolute;
        top: 40px;
        left: 40px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }
      .top {
        margin-left: 159px;
        margin-top: 86px;

        .label {
          display: inline-block;
          width: 46px;
        }
        .top-box {
          width: 100%;
          .label {
            font-size: 14px;
          }
          div {
            display: flex;
            // justify-content: space-between;
            margin-bottom: 14px;
          }
        }
      }
      .bottom {
        width: 100%;
        border-radius: 10px;
        background-color: #fff;
        height: 124px;
      }
      .el-button {
        position: absolute;
        left: 50%;
        bottom: 16px;
        background-color: #cea257;
        border: none;
        color: #fff;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        font-size: 13px;
      }
    }
    .home-top-center {
      width: 1180px;
      min-width: 1180px;
      height: 380px;
      display: flex;
      margin-left: 40px;
      // justify-content: space-between;
      // align-content: center;
      flex-wrap: wrap;
      font-size: 51px;
      align-items: center;
      .advertisement {
        text-align: center;
        font-size: 32px;
        line-height: 110px;
        background-color: #fff;
        border-radius: 10px;
        width: 100%;
        height: 124px;
        // background: url("../../assets/img/home_banner_right_bg.jpg") repeat-x;
        img {
          height: 100%;
        }
      }
      .icon {
        width: 180px;
        height: 180px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 1px 6px 13px 0px #d0d0d0;
        border-radius: 25px;
        width: 180px;
        height: 180px;
        margin-right: 16px;
        background-blend-mode: normal, normal;
        box-shadow: 1px 6px 13px 0px #d0d0d0;
        border-radius: 25px;
        // .activeIcon {
        //   color: #409eff;
        // }
        .big {
          font-size: 44px;
          // font-weight: 600;
        }
        .weight {
          font-weight: 600;
        }
      }
    }
    .home-top-right {
      width: 380px;
      // height: 300px;
      // font-weight: 700;
      background-color: #fff;
      border-radius: 10px;
      // padding-top: 10px;
      border: 1px solid rgb(206, 162, 87);
      background-color: #fff;

      .msg-top {
        width: 100%;
        text-align: center;
        .msg-title {
          display: block;
          font-size: 16px;
        }
        .msg-tab {
          .all {
            margin-left: 70px;
          }
        }
      }
    }
  }

  .home-bottpm {
    width: 100%;
    height: 355px;
    margin-top: 30px;
    .borderDecoration {
      position: absolute;
      top: 0px;
      left: 30px;
    }
    .advertisement {
      width: 200px;
      min-width: 200px;
      text-align: center;
      font-size: 30px;
      height: 100%;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .home-bottom-center {
      background-color: #fff;
      margin-left: 40px;
      // flex: 1;
      width: 680px;
      min-width: 680px;
      box-shadow: 1px 6px 13px 0px #d0d0d0;
      border-radius: 25px;
      padding: 23px 30px;
      position: relative;
      .msg-top {
        text-align: left;
        .msg-title {
          display: block;
          font-size: 16px;
          margin: 0;
        }
      }
    }
    .home-bottpm-left {
      width: 620px;
      min-width: 620px;
      padding: 23px 30px;
      background-color: #feffff;
      box-shadow: 1px 6px 13px 0px #d0d0d0;
      border-radius: 25px;
      position: relative;
      .title {
        font-size: 16px;
      }
      .label {
        margin-top: 5px;
      }
    }
    .statisticsBox {
      display: flex;
      flex-wrap: wrap;
      div {
        width: 33.3%;
        margin-top: 20px;
      }
    }
    .roll {
      margin-left: 40px;
      width: 460px;
      height: 355px;
      box-shadow: 1px 6px 13px 0px #d0d0d0;
      border-radius: 25px;
      background-color: #fff;
      position: relative;
      padding: 23px 30px;
      .roll-title {
        font-size: 16px;
        // margin-bottom: 25px;
      }
    }
    .buyer {
      // background-color: #f8f8f8;
      // border: 1px solid #ebeef5;
      // padding: 20px;

      > div {
        height: 250px;
        overflow: hidden;
      }
      ul {
        display: flex;
        // justify-content: center;
        flex-wrap: wrap;
        animation: move 8s linear infinite;
        li {
          // width: calc(50% - 30px);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          padding: 4px 10px;
          background-color: #fff;
          border-radius: 30px;
          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
          p {
            font-size: 14px;
            // color: #999;
            margin-left: 15px;
            span {
              color: #ff6600;
              // padding: 0 2px;
            }
          }
        }
      }
      @keyframes move {
        0% {
          transform: translateY(0);
        }
        50% {
          // transform: translateY(-82px);
          transform: translateY(-125px);
        }

        100% {
          // transform: translateY(-165px);
          transform: translateY(-240px);
        }
      }
    }
    .home-bottpm-right {
      width: 33%;
      display: flex;
      background-color: #fff;
      border-radius: 10px;
      padding: 20px;
      margin-left: 20px;
    }
  }
}
</style>
